/// <reference path="notificationHubServiceBase.ts" />

module ProcessList {
    export class AgentNotificationsHubService extends NotificationHubServiceBase {
        static $inject = ["$rootScope", "Hub", "$timeout"];
        private currentEnvironment: string;
        constructor($rootScope: ng.IRootScopeService, Hub, $timeout: ng.ITimeoutService) {
            var listeners = <NotificationListeners>{
                "agentStatusesUpdated": function (agentStatusNotification) {
                    console.log("agent updated", agentStatusNotification);
                    $rootScope.$emit("agentStatusNotification", agentStatusNotification);
                }
            }

            super($rootScope, Hub, $timeout, "AgentHub", listeners, ['ChangeSubscribedEnvironment']);
        }

        public changeSubscribedEnvironment(newEnvironment: string) {
            if(this.startPromise){
            this.startPromise.then(() => {
                this.hub.ChangeSubscribedEnvironment(this.currentEnvironment, newEnvironment);
                this.currentEnvironment = newEnvironment;
            });
        }
        }
    }

     module.service("AgentNotificationsHubService", AgentNotificationsHubService);
}